module.exports = "<div class=\"lui-textfield__wrapper\"><slot name=\"icon\"></slot><slot></slot><slot name=\"controls\"></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-textfield/theme/lui-textfield.html
// module id = 146
// module chunks = 0 1 8 22